export class ProcessMassUpdateFileRequest {
    EmployeeID: number;
    FileName: string;
    MassUpdateEntityID: number;
}

export default ProcessMassUpdateFileRequest;